import React, { forwardRef, useState } from 'react';
import { IconEye } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import DrugFoodMonographModal from './Monograph/DrugFoodMonographModal';
import drugsApiService from '../../../../services/drugsapi.service';
import PopoverInfoIcon from '../../../../components/PopoverInfoIcon/PopoverInfoIcon';
import InfoUnavailable from '../../../../components/common/InfoUnavailable';

const significanceDescriptionInfo = {
  'Most significant': '',
  'More significant': '',
  Significant: '',
  'Less significant': '',
  'Minor significance': '',
};
const DrugFoodInteractions = forwardRef(function (
  { drugFoodInteractions },
  ref,
) {
  const [showModal, setShowModal] = useState(false);
  const [monoGraphData, setMonoGraphData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFetchMonograph = async (monographId) => {
    setLoading(true);
    try {
      const data = await drugsApiService.getDrugFoodMonograph(monographId);

      setMonoGraphData(data);
      setShowModal(true);
    } catch (error) {
      console.error('Error fetching monograph:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      ref={ref}
      className="mb-36 scroll-offset"
      id="drug-food-interactions-section"
    >
      <h4>Drug-Food Interactions</h4>

      <div className="accordion-body">
        {drugFoodInteractions?.result?.length ? (
          <div>
            <ul className="indicator">
              {drugFoodInteractions.result.map((interaction, index) => (
                <div key={`drug-food-interaction-${index}`}>
                  <li className="f-18 font-semibold">
                    {interaction.AdviceMessage}
                  </li>
                  <div className="">
                    <div className="row">
                      <div className=" col-sm-6 col-12 drug-info">
                        <label>Clinical Result</label>
                        <p>{interaction.ClinicalResult}</p>
                      </div>
                      <div className=" col-sm-6 col-12 drug-info">
                        <label>
                          Significance Description
                          <PopoverInfoIcon
                            headerContent={'Significance Description'}
                            popoverInfo={significanceDescriptionInfo}
                          />
                        </label>
                        <p>{interaction.SignificanceDesc}</p>
                      </div>
                      <div className=" col-sm-6 col-12 drug-info">
                        <label>Monograph </label>
                        <button
                          type="button"
                          className="btn view-btn"
                          onClick={() =>
                            handleFetchMonograph(interaction.MonographID)
                          }
                          disabled={loading}
                        >
                          <IconEye size={18} className="ti ti-eye" />
                          {loading ? 'Loading...' : 'View'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </ul>
          </div>
        ) : (
          <InfoUnavailable />
        )}
      </div>
      <DrugFoodMonographModal
        show={showModal}
        onHide={() => setShowModal(false)}
        monoGraphData={monoGraphData}
        loading={loading}
      />
    </div>
  );
});

DrugFoodInteractions.propTypes = {
  drugFoodInteractions: PropTypes.object.isRequired,
};

DrugFoodInteractions.displayName = 'DrugFoodInteractions';

export default DrugFoodInteractions;
